import React from 'react'
import background from '../images/bg.jpg';

const BottomSwiper = () => {
    const divStyle = {
        backgroundImage: `url(${background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      };
    return (
        <div className='rounded-b-full  pb-8 shadow-2xl' style={divStyle}></div>
    )
}

export default BottomSwiper 